import * as React from 'react';
import { useContext } from 'react';
import { Header } from 'telia-front-react';
import ActionsProvider from './ActionsProvider';
import { DiilHeaderContext } from './DiilHeader';
import EmployeeMenuItemsProvider from './EmployeeMenuItemsProvider';
import { getTeliaSelfServiceUrl, getSsoApiUrl, getMainpageUrl } from './EnvironmentUrls';
import { getHeaderLanguages } from './LanguageProvider';
import NavItemsProvider from './NavItemsProvider';
import SectionProvider from './SectionProvider';
const DiilHeaderInner = () => {
    const { sso, translate, environment, client, brand, navigate, ...rest } = useContext(DiilHeaderContext);
    const sectionProvider = SectionProvider();
    const actionsProvider = ActionsProvider();
    const navItemsProvider = NavItemsProvider({ setSection: sectionProvider.setSection });
    const employeeHeaderProvider = EmployeeMenuItemsProvider();
    const redirectEmployeeAddEvent = (event) => {
        if (document.getElementById('issue-registration-form')) {
            event.preventDefault();
            const customEvent = new CustomEvent('issueFormOpened');
            window.dispatchEvent(customEvent);
        }
    };
    const getEmployeeHeader = () => {
        return {
            segment: { items: employeeHeaderProvider.employeeMenuItems },
            environment,
            actions: {
                items: [
                    {
                        url: `${getTeliaSelfServiceUrl(environment)}/teenindus/isiku-tuvastamine`,
                        label: 'Kliendi tuvastamine',
                        id: 'employeeSmartAuth',
                        icon: '#id',
                        hideLabel: true
                    },
                    {
                        url: `${getTeliaSelfServiceUrl(environment)}/teenindus/syndmused`,
                        onClick: redirectEmployeeAddEvent,
                        label: 'Lisan uue sündmuse',
                        id: 'employeeAddEvent',
                        icon: '#service-add',
                        hideLabel: true
                    },
                    {
                        url: '#',
                        label: sso.dealer ? `${sso.dealer.displayName}` : '',
                        id: 'employeeSettings',
                        icon: '#support',
                        showArrow: true,
                        dropdownContent: actionsProvider.dropdownContent('/admin/config', environment, `${getSsoApiUrl(environment, brand)}`, client),
                        dropdownPadding: 'small'
                    }
                ]
            }
        };
    };
    const handleLogoClick = (event) => {
        navigate(event);
    };
    const getLogo = () => {
        return { url: '/', onClick: handleLogoClick, text: brand === 'super' ? 'Super' : 'Diil' };
    };
    return (React.createElement(Header, { ...rest, logo: { ...getLogo() }, segment: navItemsProvider.segmentItems && navItemsProvider.segmentItems, actions: { ...actionsProvider.getHeaderActions() }, languages: getHeaderLanguages(), nav: { label: navItemsProvider.label(), tree: navItemsProvider.navItems, onTreeChange: () => undefined }, openSection: sectionProvider.section, onOpenSectionChange: sectionProvider.handleOpenSectionChange, employee: sso.dealer ? getEmployeeHeader() : undefined, accessibility: {
            url: getMainpageUrl(environment, brand) + translate('header.main.accessibility.path'),
            label: translate('header.main.accessibility.label')
        } }));
};
export default DiilHeaderInner;
//# sourceMappingURL=DiilHeaderInner.js.map